import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Link from "next/link";

interface ResultsHeroProps {
  cityName: string;
  title?: string;
}

export default function ResultsHero({ cityName, title }: ResultsHeroProps) {
  return (
    <section className="bg-[#f2f5f9]">
      <div className="customContainer mx-auto pb-4 pt-5 max-md:!px-4">
        <nav className="mb-2 text-sm text-slate-500" aria-label="مسیر صفحه">
          <ol className="flex flex-wrap items-center gap-2">
            <li className="flex items-center gap-2">
              <PhosphorIcon name="Buildings" size={14} />
              <Link href="/hotel/" className="transition hover:text-primary">
                رزرو هتل
              </Link>
            </li>
            <li
              className="flex items-center gap-2 font-semibold text-primary"
              aria-current="page"
            >
              <PhosphorIcon name="CaretLeft" size={14} aria-hidden />
              <span>هتل های {cityName}</span>
            </li>
          </ol>
        </nav>

        <h1 className="text-2xl font-bold text-slate-950">
          {title || `هتل‌های ${cityName}`}
        </h1>
      </div>
    </section>
  );
}
